import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CalendarModule } from "@bfx/primeng/calendar";
import { DataTableModule } from "@bfx/primeng/datatable";
import { DialogModule } from "@bfx/primeng/dialog";
import { DropdownModule } from "@bfx/primeng/dropdown";
import { FieldsetModule } from "@bfx/primeng/fieldset";
import { InputSwitchModule } from "@bfx/primeng/inputswitch";
import { MenuModule } from "@bfx/primeng/menu";
import { MultiSelectModule } from "@bfx/primeng/multiselect";
import { SliderModule } from "@bfx/primeng/slider";
import { SpinnerModule } from "@bfx/primeng/spinner";
import { TabViewModule } from "@bfx/primeng/tabview";

import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { BfxFindModule } from "../bfx-find/bfx-find.module";
import { BfxFindService } from "../bfx-find/bfx-find.service";
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxFindDealsComponent } from "../bfx-find-deals/bfx-find-deals.component";
import { BfxFindDealsFilterViewComponent } from "../bfx-find-deals/bfx-find-deals-filter-view.component";
import { BfxTradeBlotterModule } from "../bfx-blotter-trade/bfx-trade-blotter.module";
import { BfxInterfaceControlsModule } from "../bfx-interface-controls/bfx-interface-controls.module";
import { BfxFindDealsContextMenuService } from "./bfx-find-deals-contextmenu.service";
import { BfxFindDealsContextMenu } from "./bfx-find-deals-contextmenu";
import { BfxFindDealsService } from "./bfx-find-deals.service";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BmarkSummaryModule } from "../bfx-bmark-summary/bmark-summary.module";
import { BfxFindDealsFilterDataFactory } from "./bfx-find-deals-filter-data-factory";
import { BaseComponentsModule } from "shared/base-components/base-components.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    AutoCompleteModule,
    BfxElementsLibraryModule,
    BfxInterfaceControlsModule,
    ButtonModule,
    CalendarModule,
    CommonModule,
    DataTableModule,
    DialogModule,
    DropdownModule,
    FieldsetModule,
    FlexLayoutModule,
    FormsModule,
    InputSwitchModule,
    MenuModule,
    MultiSelectModule,
    PerfectScrollbarModule,
    SliderModule,
    SpinnerModule,
    TabViewModule,
    TranslateModule,
    BfxBlotterFilterModule,
    BfxSharedModule,
    BfxFindModule,
    BfxTradeBlotterModule,
    BmarkSummaryModule,
    NativeDesktopModule,
    BaseComponentsModule,
  ],
  declarations: [BfxFindDealsComponent, BfxFindDealsFilterViewComponent, BfxFindDealsContextMenu],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    BfxFindDealsContextMenuService,
    BfxBaseBlotterColumnSelectorService,
    BfxFindDealsService,
    { provide: BfxFindService, useExisting: BfxFindDealsService },
    BfxFindDealsFilterDataFactory,
  ],
  exports: [BfxFindDealsComponent, BfxFindDealsFilterViewComponent],
  bootstrap: [BfxFindDealsComponent],
})
export class BfxFindDealsModule {}
